
interface StatsCardProps {
  title: string;
  value: string;
  icon: string;
  color: 'blue' | 'green' | 'purple' | 'orange' | 'red' | 'indigo';
}

export default function StatsCard({ title, value, icon, color }: StatsCardProps) {
  const getColorClasses = (color: string) => {
    switch (color) {
      case 'blue':
        return {
          text: 'text-blue-600',
          cardBg: 'bg-blue-50',
          iconBg: 'bg-blue-100'
        };
      case 'green':
        return {
          text: 'text-green-600',
          cardBg: 'bg-green-50',
          iconBg: 'bg-green-100'
        };
      case 'purple':
        return {
          text: 'text-purple-600',
          cardBg: 'bg-purple-50',
          iconBg: 'bg-purple-100'
        };
      case 'orange':
        return {
          text: 'text-orange-600',
          cardBg: 'bg-orange-50',
          iconBg: 'bg-orange-100'
        };
      case 'red':
        return {
          text: 'text-red-600',
          cardBg: 'bg-red-50',
          iconBg: 'bg-red-100'
        };
      case 'indigo':
        return {
          text: 'text-indigo-600',
          cardBg: 'bg-indigo-50',
          iconBg: 'bg-indigo-100'
        };
      default:
        return {
          text: 'text-blue-600',
          cardBg: 'bg-blue-50',
          iconBg: 'bg-blue-100'
        };
    }
  };

  const colors = getColorClasses(color);

  return (
    <div className={`${colors.cardBg} rounded-xl p-4 lg:p-6 border-2 border-gray-200 hover:shadow-lg hover:-translate-y-1 transition-all duration-200`}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
          <p className={`text-xl lg:text-2xl font-bold ${colors.text}`}>{value}</p>
        </div>
        <div className={`w-10 h-10 lg:w-12 lg:h-12 ${colors.iconBg} rounded-full flex items-center justify-center ml-3`}>
          <i className={`${icon} ${colors.text} text-xl lg:text-2xl`}></i>
        </div>
      </div>
    </div>
  );
}
